export const DisallowedContentTypes = [
  "message/delivery-status",
  "message/rfc822",
  "text/calendar",
];
